<template>
  <div>
    <v-dialog
      v-model="dialog"
      max-width="550px"
      transition="dialog-transition"
    >
      <v-sheet>
        <v-toolbar dark class="primary">
          <v-btn
            icon
            @click="onClose"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title>{{ titleTransaccion }}</v-toolbar-title>
        </v-toolbar>
        <v-form
          ref="form"
          v-model="valid"
        >
          <v-container>
            <!-- Información de transferencia origen -->
            <template v-if="edited.transferencia_origen">
              <div class="subtitle-1">Transferencia recibida</div>
              <v-list-item three-line dense>
                <v-list-item-avatar>
                    <v-icon>mdi-credit-card</v-icon>
                </v-list-item-avatar>
                <v-list-item-content>
                  <v-list-item-title>{{ edited.transferencia_origen.numero }}</v-list-item-title>
                  <v-list-item-subtitle>{{ edited.transferencia_origen.razon_social }}</v-list-item-subtitle>
                  <v-list-item-subtitle>{{ edited.transferencia_origen.detalle }}</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </template>
            <v-divider class="my-1"></v-divider>
            <v-text-field
              v-if="fecha"
              :value="fecha | moment('DD/MM/YYYY')"
              readonly
              label="Fecha"
              prepend-icon="mdi-calendar"
              color="primary"
            ></v-text-field>
            <v-text-field
              v-else
              readonly
              label="Fecha"
              prepend-icon="mdi-calendar"
              color="primary"
            ></v-text-field>
            <v-text-field
              :value="transaccionDetalle"
              readonly
              label="Detalle"
              prepend-icon="mdi-text-short"
              color="primary"
            ></v-text-field>
            <v-divider v-if="edited.glosas && edited.glosas.length > 0" class="my-1"></v-divider>
            <template v-if="edited.glosas && edited.glosas.length > 0">
              <v-subheader>Observaciones</v-subheader>
            </template>
            <template v-for="(glosa, index) in edited.glosas">
              <v-list-item :key="`glosa-${index}`" two-line>
                <v-list-item-content>
                  <v-list-item-title class="text-wrap">{{ glosa.detalle }}</v-list-item-title>
                  <v-list-item-subtitle>{{ glosa.autor }}</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
              <v-divider v-if="index < edited.glosas.length - 1" :key="`glosa-div-${index}`" inset></v-divider>
            </template>
            <v-divider v-if="edited.glosas && edited.glosas.length > 0" class="my-1"></v-divider>
            <v-text-field
              v-if="coeficiente > 1 && transaccionTipo !== 'Credito'"
              :value="cantidad / coeficiente"
              readonly
              label="Cantidad"
              prepend-icon="mdi-weight-kilogram"
              color="primary"
            ></v-text-field>
            <v-text-field
              v-else-if="transaccionTipo !== 'Credito'"
              :value="(cantidad / coeficiente) | formatToThreeDecimals"
              readonly
              label="Kilos"
              prepend-icon="mdi-weight-kilogram"
              color="primary"
            ></v-text-field>
            <!-- IMPORTE -->
            <v-text-field
              :value="importe | formatToTwoDecimals"
              readonly
              label="Importe"
              prepend-icon="mdi-currency-usd"
              color="primary"
            ></v-text-field>
            <!-- Información de transferencias destinos -->
            <template v-if="edited.transferencias_destinos && edited.transferencias_destinos.length > 0">
              <v-divider class="my-4"></v-divider>
              <v-subheader>Transferencias realizadas</v-subheader>
              <v-list dense three-line>
                <template v-for="(transferencia, index) in edited.transferencias_destinos">
                  <v-list-item :key="index">
                    <v-list-item-avatar>
                        <v-icon>mdi-credit-card-check</v-icon>
                    </v-list-item-avatar>
                    <v-list-item-content>
                      <v-list-item-title>{{ transferencia.numero }}</v-list-item-title>
                      <v-list-item-subtitle>{{ transferencia.razon_social }}</v-list-item-subtitle>
                      <v-list-item-subtitle>$ {{ transferencia.importe | formatToTwoDecimals }}</v-list-item-subtitle>
                      <v-list-item-subtitle>{{ transferencia.detalle }}</v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list-item>
                  <v-divider v-if="index < edited.transferencias_destinos.length - 1" :key="`div-${index}`"></v-divider>
                </template>
              </v-list>
            </template>
            <v-text-field
              :value="edited.saldo | formatToTwoDecimals"
              readonly
              :label="transaccionTipo === 'Debito' ? 'Restante' : 'Disponible'"
              prepend-icon="mdi-currency-usd"
              color="primary"
            ></v-text-field>
            <v-text-field
              v-if="transaccionTipo === 'Bono'"
              :value="kilosAFavor | formatToThreeDecimals"
              readonly
              label="Kilos a favor"
              prepend-icon="mdi-weight-kilogram"
              color="primary"
            ></v-text-field>
            <!-- Distribución de Saldos -->
            <template v-if="edited.detalle_saldos">
              <v-divider class="my-4"></v-divider>
              <v-subheader class="font-weight-bold primary--text">Distribución de Saldos</v-subheader>
              <v-row dense class="px-2 mb-2">
                <v-col cols="6" v-if="saldoSubsidio > 0">
                  <v-card outlined class="pa-2 grey lighten-4">
                    <div class="caption text-uppercase font-weight-medium text-truncate grey--text text--darken-1">Subsidio</div>
                    <div class="font-weight-bold success--text" style="font-size: 1.15rem; line-height: 1.2;">
                      $ {{ saldoSubsidio | formatToTwoDecimals }}
                    </div>
                    <div class="caption font-weight-bold grey--text text--darken-2 mt-1">
                      {{ subsidioKilos | formatToThreeDecimals }} Kg
                    </div>
                  </v-card>
                </v-col>
                <v-col cols="6" v-if="saldoUsuario > 0">
                  <v-card outlined class="pa-2 grey lighten-4">
                    <div class="caption text-uppercase font-weight-medium text-truncate grey--text text--darken-1">Usuario</div>
                    <div class="title font-weight-bold warning--text">$ {{ saldoUsuario | formatToTwoDecimals }}</div>
                  </v-card>
                </v-col>
                <v-col cols="6" v-if="saldoPleno > 0">
                  <v-card outlined class="pa-2 grey lighten-4">
                    <div class="caption text-uppercase font-weight-medium text-truncate grey--text text--darken-1">Pleno</div>
                    <div class="title font-weight-bold error--text">$ {{ saldoPleno | formatToTwoDecimals }}</div>
                  </v-card>
                </v-col>
                <v-col cols="6" v-if="saldoDemas > 0">
                  <v-card outlined class="pa-2 grey lighten-4">
                    <div class="caption text-uppercase font-weight-medium text-truncate grey--text text--darken-1">Otros / Demás</div>
                    <div class="title font-weight-bold info--text">$ {{ saldoDemas | formatToTwoDecimals }}</div>
                  </v-card>
                </v-col>
              </v-row>
            </template>

            <!-- Historial de Imputaciones Paso a Paso -->
            <template v-if="edited.imputaciones && edited.imputaciones.length > 0">
              <v-divider class="my-4"></v-divider>
              <v-subheader class="font-weight-bold primary--text">Historial de Imputaciones</v-subheader>
              <v-timeline dense align-top class="px-2 mb-2">
                <v-timeline-item
                  v-for="(imp, idx) in sortedImputaciones"
                  :key="`imp-${idx}`"
                  :color="imp.tipo === 'destino' ? 'error' : 'success'"
                  small
                  fill-dot
                >
                  <v-card class="elevation-1">
                    <v-card-text class="pa-2">
                      <div class="d-flex justify-space-between align-center mb-1">
                        <span class="caption font-weight-bold grey--text">{{ imp.fecha | moment('DD/MM/YYYY') }}</span>
                        <v-chip
                          x-small
                          :color="imp.tipo === 'destino' ? 'error lighten-4 error--text' : 'success lighten-4 success--text'"
                          class="font-weight-bold"
                          label
                        >
                          {{ imp.tipo === 'destino' ? 'Pago a Débito' : 'Cobro con Pago' }}
                        </v-chip>
                      </div>
                      
                      <div class="caption grey--text text--darken-1 mb-2">
                        <div><strong>Transac. asociada:</strong> {{ imp.detalle }}</div>
                        <div class="mt-1">
                          <strong>Total transac.:</strong> 
                          <span v-if="Math.abs(imp.asoc_cantidad) > 0 && !isBonoImputation(imp)">{{ imp.asoc_cantidad | formatToThreeDecimals }} Kg / </span>
                          <span>$ {{ imp.asoc_importe | formatToTwoDecimals }}</span>
                        </div>
                      </div>
                      
                      <v-divider class="my-1"></v-divider>
                      
                      <div class="d-flex justify-space-between align-center my-1">
                        <span class="caption grey--text">Importe Imputado:</span>
                        <span class="body-2 font-weight-bold">$ {{ imp.importe | formatToTwoDecimals }}</span>
                      </div>
                      <div class="d-flex justify-space-between align-center my-1" v-if="(imp.cantidad_origen > 0 || imp.cantidad_destino > 0) && !isBonoImputation(imp)">
                        <span class="caption grey--text">Kilos Imputados:</span>
                        <span class="body-2 font-weight-bold">
                          {{ (imp.tipo === 'destino' ? imp.cantidad_origen : imp.cantidad_destino) | formatToThreeDecimals }} Kg
                        </span>
                      </div>

                      <v-divider class="my-1"></v-divider>
                      
                      <div class="d-flex justify-space-between align-center my-1">
                        <span class="caption grey--text">Saldo Resultante:</span>
                        <span class="body-2 font-weight-bold">
                          <template v-if="transaccionTipo === 'Debito'">
                            $ {{ imp.saldo_destino | formatToTwoDecimals }}
                          </template>
                          <template v-else>
                            <template v-if="transaccionTipo === 'Bono'">
                              {{ (imp.saldo_origen) | formatToThreeDecimals }} Kg
                            </template>
                            <template v-else>
                              $ {{ imp.saldo_origen | formatToTwoDecimals }}
                            </template>
                          </template>
                        </span>
                      </div>

                    </v-card-text>
                  </v-card>
                </v-timeline-item>
              </v-timeline>
            </template>

            <v-text-field
              :value="edited.created_at | moment('DD/MM/YYYY HH:mm')"
              readonly
              label="Creado"
              prepend-icon="mdi-calendar"
              color="primary"
            ></v-text-field>
            <v-text-field
              :value="edited.autor"
              readonly
              label="Autor"
              prepend-icon="mdi-account"
              color="primary"
            ></v-text-field>
            <!-- FOOTER -->
            <v-footer>
              <credito-print v-if="transaccionTipo === 'Credito'"></credito-print>
              <v-spacer></v-spacer>
              <v-btn
                :disabled="!$can('transacciones.destroy') || cerrada || edited.deleted_at !== null"
                color="error"
                @click="onSubmit"
                :loading="loading"
              >
                <v-icon left>mdi-delete</v-icon>
                Borrar
              </v-btn>
            </v-footer>
          </v-container>
        </v-form>
      </v-sheet>
    </v-dialog>
  </div>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex'
import KilosInput from '@/components/KilosInput'
// import InportesInput from '@/components/ImportesInput'
import PrecioMixin from '@/mixins/Precios'
import CreditoPrint from '@/pages/creditos/PrintComponent'
export default {
  name: 'TransaccionesEditComponent',
  components: {
    'kilos-input': KilosInput,
    'credito-print': CreditoPrint,
    // 'importes-input': InportesInput,
  },
  mixins: [PrecioMixin],
  model: {
    prop: 'selected',
    event: 'change'
  },
  props: {
    selected: Boolean
  },
  data () {
    return {
      valid: false,
      focusGas: false,
      precio: 0,
    }
  },
  beforeDestroy () {
    // Remueve el event listener en el gancho beforeDestroy
    // window.removeEventListener('keydown', this.handleKeyboard);
    this.onClearEdited()
    this.onClearSelected()
  },
  created () {
    // this.cuentaId = this.selectedId
  },
  computed: {
    ...mapGetters('Cuentas', ['cerrada']),
    ...mapGetters('Transacciones', ['edited', 'loading']),
    dialog: {
      get () {
        return this.selected
      },
      set (value) {
        this.$emit('change', value)
      }
    },
    titleTransaccion () {
      switch (this.transaccionTipo) {
        case 'Credito':
          return 'Credito';
        case 'Debito':
          return 'Debito';
        case 'Bono':
          return 'Descarga de subsidio';
        default:
          return ''; // O podrías manejar un caso por defecto si es necesario
      }
    },
    transaccionTipo: {
      get () {
        return this.edited.transaccion_tipo
      },
      set (value) {
        this.setEdited({
          ...this.edited,
          transaccion_tipo: value
        })
      }
    },
    transaccionDetalle: {
      get () {
        return this.edited.transaccion_detalle
      },
      set (value) {
        this.setEdited({
          ...this.edited,
          transaccion_detalle: value
        })
      }
    },
    glosas () {
      return this.edited.glosas
    },
    fecha: {
      get () {
        return this.edited.fecha
      },
      set (value) {
        this.setEdited({
          ...this.edited,
          fecha: value
        })
      }
    },
    cuentaId: {
      get () {
        return this.edited.cuenta_id
      },
      set (value) {
        this.setEdited({
          ...this.edited,
          cuenta_id: value
        })
      }
    },
    cuentaSaldoId: {
      get () {
        return this.edited.cuenta_saldo_id
      },
      set (value) {
        this.setEdited({
          ...this.edited,
          cuenta_saldo_id: value
        })
      }
    },
    cantidad: {
      get () {
        return this.edited.cantidad
      },
      set (value) {
        this.setEdited({
          ...this.edited,
          cantidad: value
        })
      }
    },
    coeficiente: {
      get () {
        return this.edited.coeficiente
      },
      set (value) {
        this.setEdited({
          ...this.edited,
          coeficiente: value
        })
      }
    },
    importe: {
      get () {
        return this.edited.importe
      },
      set (value) {
        this.setEdited({
          ...this.edited,
          importe: value
        })
      }
    },
    createdAt () {
      return this.edited.created_at
    },
    updatedAt() {
      return this.edited.updated_at
    },
    kilosAFavor () {
      const saldo = Number(this.edited && this.edited.saldo) || 0
      if (this.transaccionTipo !== 'Bono' || saldo <= 0) return 0
      const precio = this.precioByVigencia(this.$moment().format('YYYY-MM-DD'))
      const subsidio = precio && Number(precio.subsidio) ? Number(precio.subsidio) : 0
      if (!subsidio) return 0
      return saldo / subsidio
    },
    saldoSubsidio() {
      if(!this.edited.detalle_saldos) return 0;
      return this.edited.detalle_saldos.subsidio;
    },
    subsidioKilos() {
      const saldo = Number(this.saldoSubsidio) || 0
      if (saldo <= 0) return 0
      const fechaBase = this.edited.fecha ? this.$moment(this.edited.fecha).format('YYYY-MM-DD') : this.$moment().format('YYYY-MM-DD')
      const precio = this.precioByVigencia(fechaBase)
      const subsidio = precio && Number(precio.subsidio) ? Number(precio.subsidio) : 0
      if (!subsidio) return 0
      return saldo / subsidio
    },
    saldoSubsidioKilos() {
      if(!this.edited.detalle_saldos) return 0;
      return this.edited.detalle_saldos.subsidio_kilos;
    },
    saldoPleno() {
      if(!this.edited.detalle_saldos) return 0;
      return this.edited.detalle_saldos.pleno;
    },
    saldoPlenoKilos() {
      if(!this.edited.detalle_saldos) return 0;
      return this.edited.detalle_saldos.pleno_kilos;
    },
    saldoPlenoTotal() {
      if(!this.edited.detalle_saldos) return 0;
      return this.edited.detalle_saldos.pleno_total;
    },
    saldoUsuario() {
      if(!this.edited.detalle_saldos) return 0;
      return this.edited.detalle_saldos.usuario;
    },
    saldoDemas() {
      if(!this.edited.detalle_saldos) return 0;
      return this.edited.detalle_saldos.demas;
    },
    sortedImputaciones () {
      if (!this.edited.imputaciones) return []
      return [...this.edited.imputaciones].sort((a, b) => {
        return a.id - b.id
      })
    },
  },
  watch: {
    selectedId (newVal) {
      this.cuentaId = newVal
    },
  },
  methods: {
    ...mapActions('Cuentas', ['onRefresh']),
    ...mapActions('Transacciones', ['onFetch']),
    ...mapActions('Transacciones', ['onDelete', 'onClearEdited', 'onClearSelected']),
    ...mapMutations('Transacciones', ['setEdited']),
    isBonoImputation(imp) {
      if (!imp || !imp.detalle) return false;
      const lower = imp.detalle.toLowerCase();
      return lower.includes('bono') || lower.includes('subsidio');
    },
    onSubmit () {
      this.$refs.form.validate()
      if (this.valid) {
        const justificacion = window.prompt('Por favor, ingrese una justificación para borrar esta transacción:')
        
        if (justificacion === null) {
          return // El usuario canceló el prompt
        }

        if (justificacion.trim() === '') {
          alert('Debe ingresar una justificación para poder continuar.')
          return
        }

        this.onDelete(justificacion).then(response => {
          // this.$store.dispatch('Saldos/onFetch')
          this.$store.dispatch('Transacciones/onFetch')
          this.$store.dispatch('Cuentas/onRefresh')
          this.dialog = false
        })
      }
    },
    onClose (event) {
      event.preventDefault()
      this.dialog = false
    },
    handleKeyboard (event) {
      // if(event.key === 'Enter' && !event.ctrlKey) {
      //   this.onSubmit(event)
      // }
      // else if(event.altKey && event.key == 'k') {
      //   event.preventDefault()
      //   this.focusGas = true
      // }
    },
    onLimpiar() {
      this.onClearEdited();
      this.onClearSelected();
      this.cuentaId = this.selectedId;
    },
    onDialogOpen () {
      // Esperamos a que el diálogo esté completamente abierto
      this.$nextTick(() => {
        if (this.dialog) {
          window.addEventListener('keydown', this.handleKeyboard);
        }
        else {
          window.removeEventListener('keydown', this.handleKeyboard);
          this.onLimpiar();
        }
      });
    },
  },
}
</script>
